import { api } from '@/services';
import { QueryFilters } from '@/types/services';
import { pathWithQuery } from '@/utils/string';
import {
  CreateVoltaItemData, DeleteVoltaItemData,
  GetVoltaItemData,
  UpdateVoltaItemData,
  VoltaItem
} from '@/entities/volta-item/types';

const BASE_URL = '/volta_items';

export const getVoltaItem = (data: GetVoltaItemData): Promise<VoltaItem> =>
  api.get(`${BASE_URL}/${ data.id }`);

export const getVoltaItems = (
  filters: QueryFilters<VoltaItem> | undefined = undefined,
): Promise<VoltaItem[]> => api.get(pathWithQuery(BASE_URL, filters));

export const createVoltaItem = (data: CreateVoltaItemData): Promise<VoltaItem> =>
  api.post(BASE_URL, data);

export const updateVoltaItem = (data: UpdateVoltaItemData): Promise<VoltaItem> =>
  api.put(`${BASE_URL}/${ data.id }`, data);

export const deleteVoltaItem = ({ id }: DeleteVoltaItemData): Promise<VoltaItem> =>
  api.delete(`${BASE_URL}/${ id }`);
